export default __webpack_public_path__ + "static/media/delete-circle.7376e2af.svg";